import { createSlice } from "@reduxjs/toolkit";
import content from '../assets/site_material/content.json'
import image1 from "../assets/site_material/gallery_images/moles1.jpg";
import image2 from "../assets/site_material/gallery_images/moles2.jpg";
import image3 from "../assets/site_material/gallery_images/moles3.jpg";
import image4 from "../assets/site_material/gallery_images/moles4.jpg";
import image5 from "../assets/site_material/gallery_images/moles5.jpg";
import image6 from "../assets/site_material/gallery_images/moles6.jpg";
import image7 from "../assets/site_material/gallery_images/moles7.jpg";
import image8 from "../assets/site_material/gallery_images/moles8.jpg";
import image9 from "../assets/site_material/gallery_images/moles9.jpg";
import image10 from "../assets/site_material/gallery_images/moles10.jpg";
import image11 from "../assets/site_material/gallery_images/moles11.jpg";
import image12 from "../assets/site_material/gallery_images/moles12.jpg";

import chronology_image1 from "../assets/site_material/chronology_images/chronology1.tif";
import chronology_image2 from "../assets/site_material/chronology_images/chronology2.tif";
import chronology_image3 from "../assets/site_material/chronology_images/chronology3.tif";
import chronology_image4 from "../assets/site_material/chronology_images/chronology4.tif";
import chronology_image5 from "../assets/site_material/chronology_images/chronology5.tif";
import chronology_image6 from "../assets/site_material/chronology_images/chronology6.tif";
import chronology_image7 from "../assets/site_material/chronology_images/chronology7.tif";
import chronology_image8 from "../assets/site_material/chronology_images/chronology8.tif";
import chronology_image9 from "../assets/site_material/chronology_images/chronology9.tif";
import chronology_image10 from "../assets/site_material/chronology_images/chronology10.tif";
import chronology_image11 from "../assets/site_material/chronology_images/chronology11.tif";
import chronology_image12 from "../assets/site_material/chronology_images/chronology12.tif";



export const contentSlice = createSlice({
    name: "content",
    initialState: {
        language: "english",
        navigation: content["english"]["navigation"], 
        home: content["english"]["home"], 
        biography: content["english"]["biography"],
        gallery: content["english"]["gallery"],
        contact: content["english"]["contact"],
        videos: content["english"]["videos"],
        images: [
            {
                src: image1,
                title: "Daniele Giulio Moles",
                description: "Daniele Giulio Moles",
            },
            {
                src: image2,
                title: "Daniele Giulio Moles",
                description: "Auditorium Rai Napoli",
            },
            {
                src: image3,
                title: "Daniele Giulio Moles",
                description: "Fermo Teatro dell'Aquila",
            },
            {
                src: image4,
                title: "Daniele Giulio Moles",
                description: "Fermo Teatro dell'Aquila",
            },
            {
                src: image5,
                title: "Daniele Giulio Moles",
                description: "Auditorium Rai Napoli",
            },
            {
                src: image6,
                title: "Daniele Giulio Moles",
                description: "Daniele Giulio Moles",
            },
            {
                src: image7,
                title: "Daniele Giulio Moles",
                description: "Con Nicanor Zabaleta",
            },
            {
                src: image8,
                title: "Daniele Giulio Moles",
                description: "Prova in Francoforte",
            },
            {
                src: image9,
                title: "Daniele Giulio Moles",
                description: "Tulsa Opera Trovatore",
            },
            {
                src: image10,
                title: "Daniele Giulio Moles",
                description: "Paris Piano Conpetition",
            },
            {
                src: image11,
                title: "Daniele Giulio Moles",
                description: "Prova per Opera di Roma",
            },
            {
                src: image12,
                title: "Daniele Giulio Moles",
                description: "con M.° Franco Ferrara",
            },
        ],
        chronology_images: [
            {
                src: chronology_image1,
                title: " ",
                description: " "
            },
            {
                src: chronology_image2,
                title: " ",
                description: " "
            },
            {
                src: chronology_image3,
                title: " ",
                description: " "
            },
            {
                src: chronology_image4,
                title: " ",
                description: " "
            },
            {
                src: chronology_image5,
                title: " ",
                description: " "
            },
            {
                src: chronology_image6,
                title: " ",
                description: " "
            },
            {
                src: chronology_image7,
                title: " ",
                description: " "
            },
            {
                src: chronology_image8,
                title: " ",
                description: " "
            },
            {
                src: chronology_image9,
                title: " ",
                description: " "
            },
            {
                src: chronology_image10,
                title: " ",
                description: " "
            },
            {
                src: chronology_image11,
                title: " ",
                description: " "
            },
            {
                src: chronology_image12,
                title: " ",
                description: " "
            },  
        ]

    },

    reducers: {
        setWebsiteLanguage: (state, action) => {
            
            state.language = action.payload
            state.navigation = content[action.payload]["navigation"]
            state.home = content[action.payload]["home"]
            state.biography = content[action.payload]["biography"]
            state.gallery = content[action.payload]["gallery"]
            state.contact = content[action.payload]["contact"]
            state.videos = content[action.payload]["videos"]
        }
    }
})

export const { setWebsiteLanguage } = contentSlice.actions;

export default contentSlice.reducer;